import React, { Component } from 'react';
import { pathOr } from 'ramda';

import XMLFields from './XMLFields';

export default type => {
    const fieldsXML = [
        { name: 'DocCommon.Company', label: type, disabled: true, type: "Input" },
        { name: 'SomeFormMain.Text', label: 'Text', maxLength: "1023", autosize: { minRows: 4, maxRows: 10 } },
    ];

    return class SomeFormMain extends Component {
        componentDidMount() {
            const { event } = this.props;

            if (event) {
                const related = pathOr('', [type, 0, 'text'], event.details);

                setTimeout(() => {
                    this.props.form.change('result.xmlbody.DocCommon.Company', related || '');
                    this.props.form.change('result.xmlbody.DocCommon.DocName', 'Комментарий');
                }, 0);
            }
        }

        render () {
            return (
                <div>
                    <XMLFields fieldsXML={fieldsXML} translatePrefix="SomeFormMain"/>
                </div>
            );
        }
    };
}
